import { render, staticRenderFns } from "./OptionModal.vue?vue&type=template&id=1859be76&scoped=true"
import script from "./OptionModal.vue?vue&type=script&lang=js"
export * from "./OptionModal.vue?vue&type=script&lang=js"
import style0 from "./OptionModal.vue?vue&type=style&index=0&id=1859be76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859be76",
  null
  
)

export default component.exports